/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ModelDate } from './ModelDate';
import {
    ModelDateFromJSON,
    ModelDateFromJSONTyped,
    ModelDateToJSON,
    ModelDateToJSONTyped,
} from './ModelDate';
import type { Name } from './Name';
import {
    NameFromJSON,
    NameFromJSONTyped,
    NameToJSON,
    NameToJSONTyped,
} from './Name';

/**
 * 
 * @export
 * @interface Csl
 */
export interface Csl  {
    /**
     * 
     * @type {CslTypeEnum}
     * @memberof Csl
     */
    type?: CslTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    mmsType?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Csl
     */
    categories?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    journalAbbreviation?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    shortTitle?: string;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    author?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    editor?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    collection_editor?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    composer?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    container_author?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    director?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    interviewer?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    illustrator?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    original_author?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    recipient?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    reviewed_author?: Array<Name>;
    /**
     * 
     * @type {Array<Name>}
     * @memberof Csl
     */
    translator?: Array<Name>;
    /**
     * 
     * @type {ModelDate}
     * @memberof Csl
     */
    accessed?: ModelDate;
    /**
     * 
     * @type {ModelDate}
     * @memberof Csl
     */
    container?: ModelDate;
    /**
     * 
     * @type {ModelDate}
     * @memberof Csl
     */
    event_date?: ModelDate;
    /**
     * 
     * @type {ModelDate}
     * @memberof Csl
     */
    issued?: ModelDate;
    /**
     * 
     * @type {ModelDate}
     * @memberof Csl
     */
    original_date?: ModelDate;
    /**
     * 
     * @type {ModelDate}
     * @memberof Csl
     */
    submitted?: ModelDate;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    _abstract?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    annote?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    archive?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    archive_location?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    archive_place?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    authority?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    call_number?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    chapter_number?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    citation_number?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    citation_label?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    collection_number?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    collection_title?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    container_title?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    container_title_short?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    dimensions?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    DOI?: string;
    /**
     * 
     * @type {any}
     * @memberof Csl
     */
    edition?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    event?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    event_place?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    first_reference_note_number?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    genre?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    ISBN?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    ISSN?: string;
    /**
     * 
     * @type {any}
     * @memberof Csl
     */
    issue?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    jurisdiction?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    keyword?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    locator?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    medium?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    note?: string;
    /**
     * 
     * @type {any}
     * @memberof Csl
     */
    number?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    number_of_pages?: string;
    /**
     * 
     * @type {any}
     * @memberof Csl
     */
    number_of_volumes?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    original_publisher?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    original_publisher_place?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    original_title?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    page?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    page_first?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    PMCID?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    PMID?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    publisher?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    publisher_place?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    references?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    reviewed_title?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    scale?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    section?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    title_short?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    URL?: string;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    version?: string;
    /**
     * 
     * @type {any}
     * @memberof Csl
     */
    volume?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Csl
     */
    year_suffix?: string;
}


/**
 * @export
 */
export const CslTypeEnum = {
    Article: 'article',
    ArticleJournal: 'article-journal',
    ArticleMagazine: 'article-magazine',
    ArticleNewspaper: 'article-newspaper',
    Bill: 'bill',
    Book: 'book',
    Broadcast: 'broadcast',
    Chapter: 'chapter',
    Dataset: 'dataset',
    Entry: 'entry',
    EntryDictionary: 'entry-dictionary',
    EntryEncyclopedia: 'entry-encyclopedia',
    Figure: 'figure',
    Graphic: 'graphic',
    Interview: 'interview',
    LegalCase: 'legal_case',
    Legislation: 'legislation',
    Manuscript: 'manuscript',
    Map: 'map',
    MotionPicture: 'motion_picture',
    MusicalScore: 'musical_score',
    Pamphlet: 'pamphlet',
    PaperConference: 'paper-conference',
    Patent: 'patent',
    PersonalCommunication: 'personal_communication',
    Post: 'post',
    PostWeblog: 'post-weblog',
    Report: 'report',
    Review: 'review',
    ReviewBook: 'review-book',
    Song: 'song',
    Speech: 'speech',
    Thesis: 'thesis',
    Treaty: 'treaty',
    Webpage: 'webpage'
} as const;
export type CslTypeEnum = typeof CslTypeEnum[keyof typeof CslTypeEnum];


/**
 * Check if a given object implements the Csl interface.
 */
export function instanceOfCsl(value: object): value is Csl {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CslFromJSON(json: any): Csl {
    return CslFromJSONTyped(json, false);
}

export function CslFromJSONTyped(json: any, ignoreDiscriminator: boolean): Csl {
    if (json == null) {
        return json;
    }
    return {
        
                  'type': json['type'] == null ? undefined : json['type'],
                  'mmsType': json['mmsType'] == null ? undefined : json['mmsType'],
                  'id': json['id'],
              'categories': json['categories'] == null ? undefined : json['categories'],
                  'language': json['language'] == null ? undefined : json['language'],
                  'journalAbbreviation': json['journalAbbreviation'] == null ? undefined : json['journalAbbreviation'],
                  'shortTitle': json['shortTitle'] == null ? undefined : json['shortTitle'],
              'author': json['author'] == null ? undefined : ((json['author'] as Array<any>).map(NameFromJSON)),
              'editor': json['editor'] == null ? undefined : ((json['editor'] as Array<any>).map(NameFromJSON)),
              'collection_editor': json['collection-editor'] == null ? undefined : ((json['collection-editor'] as Array<any>).map(NameFromJSON)),
              'composer': json['composer'] == null ? undefined : ((json['composer'] as Array<any>).map(NameFromJSON)),
              'container_author': json['container-author'] == null ? undefined : ((json['container-author'] as Array<any>).map(NameFromJSON)),
              'director': json['director'] == null ? undefined : ((json['director'] as Array<any>).map(NameFromJSON)),
              'interviewer': json['interviewer'] == null ? undefined : ((json['interviewer'] as Array<any>).map(NameFromJSON)),
              'illustrator': json['illustrator'] == null ? undefined : ((json['illustrator'] as Array<any>).map(NameFromJSON)),
              'original_author': json['original-author'] == null ? undefined : ((json['original-author'] as Array<any>).map(NameFromJSON)),
              'recipient': json['recipient'] == null ? undefined : ((json['recipient'] as Array<any>).map(NameFromJSON)),
              'reviewed_author': json['reviewed-author'] == null ? undefined : ((json['reviewed-author'] as Array<any>).map(NameFromJSON)),
              'translator': json['translator'] == null ? undefined : ((json['translator'] as Array<any>).map(NameFromJSON)),
                  'accessed': json['accessed'] == null ? undefined : ModelDateFromJSON(json['accessed']),
                  'container': json['container'] == null ? undefined : ModelDateFromJSON(json['container']),
                  'event_date': json['event-date'] == null ? undefined : ModelDateFromJSON(json['event-date']),
                  'issued': json['issued'] == null ? undefined : ModelDateFromJSON(json['issued']),
                  'original_date': json['original-date'] == null ? undefined : ModelDateFromJSON(json['original-date']),
                  'submitted': json['submitted'] == null ? undefined : ModelDateFromJSON(json['submitted']),
                  '_abstract': json['abstract'] == null ? undefined : json['abstract'],
                  'annote': json['annote'] == null ? undefined : json['annote'],
                  'archive': json['archive'] == null ? undefined : json['archive'],
                  'archive_location': json['archive_location'] == null ? undefined : json['archive_location'],
                  'archive_place': json['archive-place'] == null ? undefined : json['archive-place'],
                  'authority': json['authority'] == null ? undefined : json['authority'],
                  'call_number': json['call-number'] == null ? undefined : json['call-number'],
                  'chapter_number': json['chapter-number'] == null ? undefined : json['chapter-number'],
                  'citation_number': json['citation-number'] == null ? undefined : json['citation-number'],
                  'citation_label': json['citation-label'] == null ? undefined : json['citation-label'],
                  'collection_number': json['collection-number'] == null ? undefined : json['collection-number'],
                  'collection_title': json['collection-title'] == null ? undefined : json['collection-title'],
                  'container_title': json['container-title'] == null ? undefined : json['container-title'],
                  'container_title_short': json['container-title-short'] == null ? undefined : json['container-title-short'],
                  'dimensions': json['dimensions'] == null ? undefined : json['dimensions'],
                  'DOI': json['DOI'] == null ? undefined : json['DOI'],
                  'edition': json['edition'] == null ? undefined : json['edition'],
                  'event': json['event'] == null ? undefined : json['event'],
                  'event_place': json['event-place'] == null ? undefined : json['event-place'],
                  'first_reference_note_number': json['first-reference-note-number'] == null ? undefined : json['first-reference-note-number'],
                  'genre': json['genre'] == null ? undefined : json['genre'],
                  'ISBN': json['ISBN'] == null ? undefined : json['ISBN'],
                  'ISSN': json['ISSN'] == null ? undefined : json['ISSN'],
                  'issue': json['issue'] == null ? undefined : json['issue'],
                  'jurisdiction': json['jurisdiction'] == null ? undefined : json['jurisdiction'],
                  'keyword': json['keyword'] == null ? undefined : json['keyword'],
                  'locator': json['locator'] == null ? undefined : json['locator'],
                  'medium': json['medium'] == null ? undefined : json['medium'],
                  'note': json['note'] == null ? undefined : json['note'],
                  'number': json['number'] == null ? undefined : json['number'],
                  'number_of_pages': json['number-of-pages'] == null ? undefined : json['number-of-pages'],
                  'number_of_volumes': json['number-of-volumes'] == null ? undefined : json['number-of-volumes'],
                  'original_publisher': json['original-publisher'] == null ? undefined : json['original-publisher'],
                  'original_publisher_place': json['original-publisher-place'] == null ? undefined : json['original-publisher-place'],
                  'original_title': json['original-title'] == null ? undefined : json['original-title'],
                  'page': json['page'] == null ? undefined : json['page'],
                  'page_first': json['page-first'] == null ? undefined : json['page-first'],
                  'PMCID': json['PMCID'] == null ? undefined : json['PMCID'],
                  'PMID': json['PMID'] == null ? undefined : json['PMID'],
                  'publisher': json['publisher'] == null ? undefined : json['publisher'],
                  'publisher_place': json['publisher-place'] == null ? undefined : json['publisher-place'],
                  'references': json['references'] == null ? undefined : json['references'],
                  'reviewed_title': json['reviewed-title'] == null ? undefined : json['reviewed-title'],
                  'scale': json['scale'] == null ? undefined : json['scale'],
                  'section': json['section'] == null ? undefined : json['section'],
                  'source': json['source'] == null ? undefined : json['source'],
                  'status': json['status'] == null ? undefined : json['status'],
                  'title': json['title'] == null ? undefined : json['title'],
                  'title_short': json['title-short'] == null ? undefined : json['title-short'],
                  'URL': json['URL'] == null ? undefined : json['URL'],
                  'version': json['version'] == null ? undefined : json['version'],
                  'volume': json['volume'] == null ? undefined : json['volume'],
                  'year_suffix': json['year-suffix'] == null ? undefined : json['year-suffix'],
    };
}

export function CslToJSON(json: any): Csl {
    return CslToJSONTyped(json, false);
}

export function CslToJSONTyped(value?: Csl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'mmsType': value['mmsType'],
        'id': value['id'],
        'categories': value['categories'] == null? value['categories']: value['categories'],
        'language': value['language'],
        'journalAbbreviation': value['journalAbbreviation'],
        'shortTitle': value['shortTitle'],
        'author': value['author'] == null? value['author']: (value['author'] as Array<any>).map(NameToJSON),
        'editor': value['editor'] == null? value['editor']: (value['editor'] as Array<any>).map(NameToJSON),
        'collection-editor': value['collection_editor'] == null? value['collection_editor']: (value['collection_editor'] as Array<any>).map(NameToJSON),
        'composer': value['composer'] == null? value['composer']: (value['composer'] as Array<any>).map(NameToJSON),
        'container-author': value['container_author'] == null? value['container_author']: (value['container_author'] as Array<any>).map(NameToJSON),
        'director': value['director'] == null? value['director']: (value['director'] as Array<any>).map(NameToJSON),
        'interviewer': value['interviewer'] == null? value['interviewer']: (value['interviewer'] as Array<any>).map(NameToJSON),
        'illustrator': value['illustrator'] == null? value['illustrator']: (value['illustrator'] as Array<any>).map(NameToJSON),
        'original-author': value['original_author'] == null? value['original_author']: (value['original_author'] as Array<any>).map(NameToJSON),
        'recipient': value['recipient'] == null? value['recipient']: (value['recipient'] as Array<any>).map(NameToJSON),
        'reviewed-author': value['reviewed_author'] == null? value['reviewed_author']: (value['reviewed_author'] as Array<any>).map(NameToJSON),
        'translator': value['translator'] == null? value['translator']: (value['translator'] as Array<any>).map(NameToJSON),
        'accessed': ModelDateToJSON(value['accessed']),
        'container': ModelDateToJSON(value['container']),
        'event-date': ModelDateToJSON(value['event_date']),
        'issued': ModelDateToJSON(value['issued']),
        'original-date': ModelDateToJSON(value['original_date']),
        'submitted': ModelDateToJSON(value['submitted']),
        'abstract': value['_abstract'],
        'annote': value['annote'],
        'archive': value['archive'],
        'archive_location': value['archive_location'],
        'archive-place': value['archive_place'],
        'authority': value['authority'],
        'call-number': value['call_number'],
        'chapter-number': value['chapter_number'],
        'citation-number': value['citation_number'],
        'citation-label': value['citation_label'],
        'collection-number': value['collection_number'],
        'collection-title': value['collection_title'],
        'container-title': value['container_title'],
        'container-title-short': value['container_title_short'],
        'dimensions': value['dimensions'],
        'DOI': value['DOI'],
        'edition': value['edition'],
        'event': value['event'],
        'event-place': value['event_place'],
        'first-reference-note-number': value['first_reference_note_number'],
        'genre': value['genre'],
        'ISBN': value['ISBN'],
        'ISSN': value['ISSN'],
        'issue': value['issue'],
        'jurisdiction': value['jurisdiction'],
        'keyword': value['keyword'],
        'locator': value['locator'],
        'medium': value['medium'],
        'note': value['note'],
        'number': value['number'],
        'number-of-pages': value['number_of_pages'],
        'number-of-volumes': value['number_of_volumes'],
        'original-publisher': value['original_publisher'],
        'original-publisher-place': value['original_publisher_place'],
        'original-title': value['original_title'],
        'page': value['page'],
        'page-first': value['page_first'],
        'PMCID': value['PMCID'],
        'PMID': value['PMID'],
        'publisher': value['publisher'],
        'publisher-place': value['publisher_place'],
        'references': value['references'],
        'reviewed-title': value['reviewed_title'],
        'scale': value['scale'],
        'section': value['section'],
        'source': value['source'],
        'status': value['status'],
        'title': value['title'],
        'title-short': value['title_short'],
        'URL': value['URL'],
        'version': value['version'],
        'volume': value['volume'],
        'year-suffix': value['year_suffix'],
    };
}


